import { CustomEvent } from './types'

export function createCustomEvent({ key, value }: CustomEvent) {
  return { target: { name: key, value } }
}
